import React from 'react';
import PropTypes from 'prop-types';

const Deactivate = ({ color = '#B5BDC5' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/UI/deactivate"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Svg-Icons/Default/18px-(All-icons)/Dropdown"
                transform="translate(1.000000, 1.000000)"
                fill={color}
                className="icon-color"
            >
                <path
                    d="M8,16 C12.418278,16 16,12.418278 16,8 C16,3.581722 12.418278,0 8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 Z M4,7 L12,7 L12,9 L4,9 L4,7 Z"
                    id="Combined-Shape"
                />
            </g>
        </g>
    </svg>
);

Deactivate.propTypes = {
    color: PropTypes.string,
};

export default Deactivate;
